import { CountryCodes } from 'enums/LocationModalEnums';
import * as Yup from 'yup';

const REQUIREDTEXT = 'Required';

const { CANADA, USA } = CountryCodes;

export const locationValidationSchema = Yup.object({
  country: Yup.string().required(REQUIREDTEXT).nullable(),
  province: Yup.string().when('countryCode', {
    is: value => value === CANADA || value === USA,
    then: Yup.string().required('Province is required'),
    otherwise: Yup.string().notRequired(),
  }),
});
